import { Feature } from '@/pinia/feature'
import {
  createColoredEntitiesDataSource,
  createMeasurementFromName,
  createValueDataSource,
  enabledEntityLevels
} from './common'

const valueDataSource = createValueDataSource('premises')
const coloredEntitiesDataSource = createColoredEntitiesDataSource('premises')
const measurementFromName = createMeasurementFromName('premises')

export const premises: Feature = {
  name: 'premises',
  enabled: true,
  isRoute: true,
  title: {
    en: 'Premises',
    sv: 'Lokaler'
  },
  access: ['FEAT_PORTFOLIO-ANALYSIS-PREMISES_READER'],
  component: 'DashboardDataSectionFlat',
  props: {
    enabledEntityLevels,
    dataSources: [
      valueDataSource('loa-bta', 0),
      valueDataSource('loah-bta', 1),
      valueDataSource('loa', 2),
      valueDataSource('loah', 3),
      coloredEntitiesDataSource('loa-bta', 4),
      coloredEntitiesDataSource('loah-bta', 5),
      coloredEntitiesDataSource('loa', 6),
      coloredEntitiesDataSource('loah', 7)
    ],
    informationFetch: 'fetch.portfolio.area.information'
  },
  children: [
    measurementFromName('loa-bta', true, true),
    measurementFromName('loah-bta', false, true),
    measurementFromName('loa'),
    measurementFromName('loah')
  ]
}
